<template>
    <div :class="{buttonUnsafe: buttonUnsafe}">
        <div v-if="prayer.isPrivate" class="privateLabel">-Private-</div>
        <div>
            {{prayer.prayer}}
        </div>
        <div class = "buttonTray" >
            <TwoClickButton @click="deletePrayer(prayer)" class="deleteButton">
                <template #UnCharged>Delete</template>
                <template #Charged>Are you sure?</template>
            </TwoClickButton>
        </div>
    </div>
</template>

<script setup>

import {ref, defineProps, defineEmits} from "vue";
import {useStore} from "vuex";
import TwoClickButton from "../buttons/TwoClickButton.vue";
import prayerService from "@/services/prayerService.js"



defineProps(["prayer"]);

const emit = defineEmits(['delete'])
const store = useStore();

let buttonUnsafe = ref(false);

async function deletePrayer(prayer){
			
        if(!buttonUnsafe.value){
            buttonUnsafe.value = true;
            let result = await prayerService.deletePrayer(prayer.wallId, prayer.prayerId, store.state.userToken);
            emit('delete', prayer)
            buttonUnsafe.value = false;
        }

}

</script>


<style scoped>
    .deleteButton{
        border-style: none;
        background: none;
        font-weight: 400;
        font-style: normal;
        font-family: 'Roboto Condensed', sans-serif;
        color: #8d0d26;
        font-size: 14px;
        line-height: 1.6;
        letter-spacing: 0px;
        white-space: nowrap;

        cursor: pointer;
    }

    .privateLabel{
        font-style: italic;
        font-weight: normal;
        font-size: .9rem;
    }

    .buttonUnsafe{
        opacity: .5;
        pointer-events: none;
    }

</style>